var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.15413 0.756104C1.42213 0.756104 0.828125 1.8731 0.828125 3.2561C0.828125 4.6391 1.42213 5.7561 2.15413 5.7561H28.6751C29.4071 5.7561 30.0011 4.6391 30.0011 3.2561C30.0011 1.8731 29.4071 0.756104 28.6751 0.756104H2.15413ZM2.15413 9.4751C1.42213 9.4751 0.828125 10.5921 0.828125 11.9751C0.828125 13.3581 1.42213 14.4751 2.15413 14.4751H28.6751C29.4071 14.4751 30.0011 13.3581 30.0011 11.9751C30.0011 10.5921 29.4071 9.4751 28.6751 9.4751H2.15413ZM2.15413 18.1941C1.42213 18.1941 0.828125 19.3111 0.828125 20.6941C0.828125 22.0771 1.42213 23.1941 2.15413 23.1941H28.6751C29.4071 23.1941 30.0011 22.0771 30.0011 20.6941C30.0011 19.3111 29.4071 18.1941 28.6751 18.1941H2.15413Z","fill":"white"}));
}

MenuInline.defaultProps = {"width":"31","height":"24","viewBox":"0 0 31 24","fill":"none"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
